// extracted by mini-css-extract-plugin
module.exports = {"badge":"_2359355","competitionLogo":"_2ae7b4a"};